import React from 'react';
import { Box, Typography, Paper, Button, Alert } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';

const ErrorState = ({ 
  title = 'Something Went Wrong',
  message = 'An unexpected error occurred. Please try again.',
  onRetry,
  showRetry = true,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        textAlign: 'center',
        border: '2px solid',
        borderColor: 'error.light',
        borderRadius: 2,
        backgroundColor: 'error.lighter',
      }}
    >
      <ErrorOutlineIcon 
        sx={{ 
          fontSize: 60, 
          color: 'error.main',
          mb: 2,
        }} 
      />
      
      <Typography variant="h6" fontWeight={600} gutterBottom color="error.dark">
        {title}
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        {message}
      </Typography>

      {showRetry && onRetry && (
        <Button
          variant="contained"
          color="error"
          startIcon={<RefreshIcon />}
          onClick={onRetry}
        >
          Try Again
        </Button>
      )}

      <Alert severity="info" sx={{ mt: 3, textAlign: 'left' }}>
        If the problem persists, please refresh the page or contact support.
      </Alert>
    </Paper>
  );
};

export default ErrorState;
